import { FC } from 'react';
import {
  TextBody,
  TextCaption,
  Spacer,
  Stack,
  Card,
  Icon,
  IconButton,
  Textarea,
  Tooltip,
  Input,
} from '@pypestream/design-system';
import { useFormContext } from 'react-hook-form';
import '../../modals/create-solution-modal/step-agent.scss';
import { useKnowledgeAgentUpload } from '../../../hooks';

interface UploadedFile {
  id: string;
  name: string;
  size: number;
  type: string;
  file: File | null;
  serverId?: string; // ID from server for existing files
}

interface TabAgentProps {
  uploadedFiles: UploadedFile[];
  viewOnly?: boolean;
  addFile: (file: File) => void;
  removeFile: (fileId: string) => void;
}

export const TabAgent: FC<TabAgentProps> = ({
  uploadedFiles,
  viewOnly,
  addFile,
  removeFile,
}) => {
  const { register } = useFormContext();

  const { customFileUpload, formatFileSize, getFileIcon } =
    useKnowledgeAgentUpload({
      addFile,
      testId: 'ps-agents-ka-file-upload',
      disabled: viewOnly,
    });

  return (
    <>
      <div>
        <Stack alignItems="center" gutter="2xsmall">
          <TextBody size="small">Brand Name</TextBody>
          <Tooltip
            placement="right"
            content="The name of your company or brand. This helps the model respond in a way that aligns with your brand identity."
          >
            <Icon name="info" color="gray" size="xsmall" />
          </Tooltip>
        </Stack>
        <Spacer size="2xsmall" />
        <Input
          test-id="ps-agents-brand-name-input"
          variant="outlined"
          placeholder="Brand Name"
          {...register('brandName')}
          disabled={viewOnly}
        />
      </div>
      <Spacer />
      <div>
        <Stack alignItems="center" gutter="2xsmall">
          <TextBody size="small">Tone</TextBody>
          <Tooltip
            placement="right"
            content="Provide context or instructions for the knowledge agent to understand its role and capabilities."
          >
            <Icon name="info" color="gray" size="xsmall" />
          </Tooltip>
        </Stack>
        <Spacer size="2xsmall" />
        <Textarea
          test-id="ps-agents-tone-textarea"
          variant="outlined"
          placeholder="Tone"
          rows={3}
          {...register('tone')}
          disabled={viewOnly}
        />
      </div>
      <Spacer />
      {!viewOnly && customFileUpload}

      {uploadedFiles?.length > 0 && (
        <>
          <Spacer size="xsmall" />
          <div className="c-create-solution-agent__files-list c-create-solution-agent__files-list--panel">
            <Stack gutter="xsmall">
              {uploadedFiles?.map((file) => (
                <Card
                  key={file.id}
                  test-id={`ps-agents-file-card-${file.id}`}
                  size="small"
                  shadow="none"
                  className="c-create-solution-agent__file c-create-solution-agent__file--large"
                >
                  <Icon
                    name={getFileIcon(file.name)}
                    className="c-create-solution-agent__file-icon"
                  />
                  <TextBody>{file.name}</TextBody>
                  <TextCaption>{formatFileSize(file.size)}</TextCaption>
                  {/* <IconButton
                    size="small"
                    name="show"
                    slot="hover-action-start"
                  /> */}
                  <IconButton
                    test-id={`ps-agents-file-delete-btn-${file.id}`}
                    size="small"
                    name="delete"
                    slot="hover-action"
                    onClick={() => removeFile(file.id)}
                  />
                </Card>
              ))}
            </Stack>
          </div>
        </>
      )}
    </>
  );
};
